<template>
    <div>
        <AlertDismiss ref="alertDismiss"></AlertDismiss>

        <b-overlay :show="loadingQuestions" class="overlay">
        <div v-for="(question, index) in localQuestions" :key="question.id">
                <div class="form-group mb-3" >
                    {{index + 1}}. {{ question.descripcion }}

                    <div class="input-group">
                        <template v-if="question.tipo == 'date'">
                            <b-form-input
                                type="date"
                                :state="questionState(question)"
                                :max="maxDate"
                                :value="question.respuesta"
                                @input="updateAnswer(question.id, $event)"
                                class="form-control"
                                :required="question.required"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback class="feedback" id="input-live-feedback">
                                Información requerida
                            </b-form-invalid-feedback>
                        </template>
                        <template v-else>
                            <span class="input-group-text">
                                <b-icon v-if="question.tipo == 'number'" small icon="hash"></b-icon>
                                <b-icon v-else small icon="type"></b-icon>
                            </span>
                            <b-form-input
                                :type="getConvertQuestionsTypeInput(question.tipo)"
                                :state="questionState(question)"
                                :value="question.respuesta"
                                @input="updateAnswer(question.id, $event)"
                                class="form-control denounce-question"
                                placeholder="Escriba su respuesta aquí"
                                :required="question.required"
                            >
                            </b-form-input>
                            <b-form-invalid-feedback class="feedback" id="input-live-feedback">
                                Información requerida
                            </b-form-invalid-feedback>
                        </template>
                    </div>
            </div>
        </div>
        </b-overlay>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { formatDateInput, convertQuestionsTypeLabel, convertQuestionsTypeInput } from '@/plugins/complianceScripts/index'

export default {
    name: 'DenounceQuestions',

    data() {
        return {
            localQuestions: [],
            maxDate: null,
        }
    },

    props: {
        anonymous: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: Array,
            default: () => []
        }
    },

    components: {
        AlertDismiss
    },

    async mounted() {
        await this.getQuestions()
        this.maxDate = formatDateInput(new Date());
    },

    computed: {
        getConvertQuestionsTypeLabel() {
            return (value) => convertQuestionsTypeLabel(value);
        },

        getConvertQuestionsTypeInput() {
            return (value) => convertQuestionsTypeInput(value);
        },

        getCovertToRequired(){
            return (value) => this.covertToRequired(value);
        },
        loadingQuestions() {
            return this.localQuestions.length == 0
        }
    },

    methods: {
        ...mapActions(["getAllQuestions"]),

        covertToRequired(value){
            return value ? 'Si' : 'No'
        },

        async getQuestions() {
            let result = await this.getAllQuestions()

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.localQuestions = result.data.map((q) => ({
                id: q.id,
                descripcion: q.description,
                tipo: q.type,
                required: q.required,
                respuesta: null,
            }));
            
            this.$emit('update', this.localQuestions);
        },

        updateAnswer(id, value) {
            const questionIndex = this.localQuestions.findIndex(q => q.id === id);
            if (questionIndex > -1) {
                this.localQuestions[questionIndex].respuesta = value;
                this.$emit('update', this.localQuestions);
            }
        },

        questionState(question) {
            return question.required && !question.respuesta ? false : null;
        },
    }
}
</script>
<style scoped>
.overlay {
    min-height: 300px;
}
</style>